module.exports = __webpack_public_path__ + "img/icon_topUp.236b209.webp";